import Dialog from './main'
const commonDialog = {
  install:function(Vue) {
    Vue.component('commonDialog', Dialog)
  }
}
// 导出该组件
export default commonDialog